module.exports = "/assets/rwc-share.png?itSgoIY";